function throttle(fn, wait) {
    var time = Date.now();

    return function () {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}

function NumberBetween() {
    Number.prototype.between = function (a, b, inclusive) {
        var min = Math.min(a, b),
            max = Math.max(a, b);

        return inclusive ? this >= min && this <= max : this > min && this < max;
    }
}

function viewportHeightLisenter() {
    //set vh variable
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    //set scrollbarwidth
    let scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        `${scrollBarWidth}px`
    );
    
}

export {
    throttle,
    NumberBetween,
    viewportHeightLisenter
}
